__turbopack_context__.v({
  "buttonLabel": "p5dHBG_buttonLabel",
  "isSubmitting": "p5dHBG_isSubmitting",
  "rotation": "p5dHBG_rotation",
  "spinner": "p5dHBG_spinner",
  "submitButton": "p5dHBG_submitButton",
});
